// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delivery-status[data-v-6436268e]{margin-left:4px;max-height:12px}.delivery-status .icon[data-v-6436268e]{max-height:12px}", ""]);
// Exports
module.exports = exports;
